/* eslint-disable no-underscore-dangle */
export var EventName;
(function (EventName) {
    EventName["FORM_SUBMIT"] = "form_submit";
    EventName["BUTTON"] = "button";
    EventName["LINK"] = "link";
    EventName["QUESTIONNAIRE"] = "questionaire";
    EventName["CHECKBOX"] = "checkbox";
    EventName["TOGGLE"] = "toggle";
})(EventName || (EventName = {}));
export var FormType;
(function (FormType) {
    FormType["TOGGLE"] = "toggle";
})(FormType || (FormType = {}));
export class DataLayerService {
    static pushEvent(name, params) {
        const isRdlInitialized = window && window._rdl;
        const isDataLayerInitialized = window && window.dataLayer;
        if (isRdlInitialized) {
            window._rdl.context.pageTitle = document.title;
            window._rdl.push(name, params);
        }
        if (isDataLayerInitialized) {
            window.dataLayer.push(params);
        }
        if (!isRdlInitialized && !isDataLayerInitialized) {
            console.error('DataLayer is not initialized on the window object');
        }
    }
}
//# sourceMappingURL=index.js.map
